import React, { useState, useEffect } from "react";
import axios from "axios";
import Weather from "../../components/Weather";
import Map from "../../components/Map";
import Detail from "../../components/Detail";
import Clock from "../../components/Clock";
import UserStatus from "../../components/UserStatus";

import searchIcon from "/assets/icon/Search.svg";
import filterIcon from "/assets/icon/Filter.svg";
import eyeIcon from "/assets/Eye.png";

import "./styles/WeatherPage.css";
import "./styles/DashboardPage.css";

function WeatherPage() {
  const [data, setData] = useState([]);
  const [activeDetail, setActiveDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const branchName =
      sessionStorage.getItem("selectedBranch") || "defaultBranchName";
    const fetchData = async () => {
      const timerLabel = `fetchData-${Date.now()}`;
      console.time(timerLabel);
      try {
        const response = await axios.get(
          `${import.meta.env.VITE_API_URL}/api/weather/${branchName}`
        );
        setData(response.data);
        setLoading(false);
      } catch (error) {
        console.error(
          `เกิดข้อผิดพลาดในการดึงข้อมูล: ${
            error.response ? error.response.data.message : error.message
          }`
        );
        setLoading(false);
      } finally {
        console.timeEnd(timerLabel);
      }
    };
    fetchData();
  }, []);

  const handleDetailClick = (row) => {
    setActiveDetail(row);
  };

  const handleCloseDetail = () => {
    setActiveDetail(null);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const sortedData = [...data].sort((a, b) => a.poleId - b.poleId);

  const filteredData = sortedData.filter(
    (row) =>
      row.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.code.toLowerCase().includes(searchTerm.toLowerCase()) ||
      row.location.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const TableHeader = () => (
    <thead>
      <tr>
        <th>No</th>
        <th>รหัสเสา</th>
        <th>ชื่อเสา</th>
        <th>พิกัด</th>
        <th>อุณหภูมิ (°C)</th>
        <th>ความชื้น (%)</th>
        <th>PM2.5 (µg/m³)</th>
        <th>สถานะเปิดปิด</th>
        <th></th>
      </tr>
    </thead>
  );

  const TableRow = ({ row, index }) => (
    <tr>
      <td>{index + 1}</td>
      <td>{row.code}</td>
      <td>{row.name}</td>
      <td>{row.location}</td>
      <td>{row.sensor ? row.sensor.temperature : "N/A"}</td>
      <td>{row.sensor ? row.sensor.humidity : "N/A"}</td>
      <td>{row.sensor ? row.sensor.pm2_5 : "N/A"}</td>
      <td>
        <UserStatus isOnline={row.active} />
      </td>
      <td>
        <img
          src={eyeIcon}
          alt="ดูรายละเอียด"
          onClick={() => handleDetailClick(row)}
          className="eye"
          style={{ cursor: "pointer" }}
        />
      </td>
    </tr>
  );

  return (
    <div className="containerPage">
      <div className="sections1">
        <h1>สภาพอากาศ</h1>
        <h2>
          <Clock />
        </h2>
      </div>

      <div className="sections2">
        <div className="area-chart-container">
          <Weather />
        </div>
        <div className="areaMap">
          <Map />
        </div>
      </div>

      <div className="section3">
        <div className="led-section">
          <div className="search-bar">
            <img src={searchIcon} alt="ค้นหา" className="search-user" />
            <input
              type="text"
              placeholder="ค้นหารหัสเสา, ชื่อเสา, หรือพิกัด"
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <div>
              <img src={filterIcon} alt="ตัวกรอง" className="filter-user" />
            </div>
          </div>
          <div className="countPole">
            <label>เสาหลักทั้งหมด <strong> {data.length}</strong> รายการ</label>
          </div>
          {loading ? (
            <div className="loading-container">
              <div className="lds-spinner">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <div>
              <table>
                <TableHeader />
                <tbody>
                  {filteredData.length > 0 ? (
                    filteredData.map((row, index) => (
                      <TableRow key={index} row={row} index={index} />
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9" style={{ textAlign: "center" }}>
                        ไม่พบข้อมูลที่ตรงกับการค้นหา
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          {activeDetail && (
            <Detail
              onClose={handleCloseDetail}
              title="รายละเอียดเสา"
              code={activeDetail?.code ?? null}
              name={activeDetail?.name ?? null}
              location={activeDetail?.location ?? null}
              lat={activeDetail?.latitude ?? null}
              lng={activeDetail?.longitude ?? null}
              active={activeDetail?.active ?? null}
              hasScreen={activeDetail?.hasScreen ?? null}
              isMaster={activeDetail?.isMaster ?? null}
              sensors={activeDetail?.sensor ?? null}
              masterId={activeDetail?.masterId ?? null}
              screenCode={activeDetail?.screenCode ?? null}
              screenModel={activeDetail?.screenModel ?? null}
              installDate={activeDetail?.installationDate ?? null}
              masterCode={activeDetail?.masterCode ?? null}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default WeatherPage;
